import { Offcanvas } from "react-bootstrap"
import ESpinner from "components/others/Spinner"
import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react";
import OffObjectCardTabs from "./OffObjectCardTabs";
import * as apiObject4Team from "api/apiObject4Team";
import { WarehouseProvider } from 'modules/warehouse';

const OffObjectCard = ({showObject, setShowObject}) => {

    const { t } = useTranslation(['Objects']);
    const [ vobjectFull, setVobjectFull ] = useState(null);

    const fetchObject = async () => {
        const resObject = await apiObject4Team.getById(showObject);
        setVobjectFull(resObject); 
    }

    const handleClose = () => { 
        setShowObject(false);
    } 
  
    useEffect(()=>{
        if (showObject) fetchObject()
            else setTimeout(() => {
                setVobjectFull(null);
            }, 300);
    },[showObject])

    return (
        <WarehouseProvider>
        <Offcanvas  
            className="off-import off-object-4team"
            show={showObject!==false} 
            onHide={handleClose}
            placement="end">
            <Offcanvas.Header 
                className="border-bottom"
                closeButton>
                <Offcanvas.Title>{vobjectFull?.object?.clientName}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                {vobjectFull 
                ? (<OffObjectCardTabs
                        setVobjectFull={setVobjectFull}
                        fetchObject={fetchObject}   
                        objectId={showObject}
                        vobjectFull={vobjectFull}/>)
                : (<ESpinner/>)}
            </Offcanvas.Body>
             
        </Offcanvas>
        </WarehouseProvider>
    ) 
}

export default OffObjectCard;